<div style="height: 200px" class="d-flex align-items-center justify-content-center">
  <nk-spinner size="lg" [text]="text() | translate" [display]="'inline-block'"></nk-spinner>
</div>
